<template>
<div style="margin-top:5px"> 
    <svg width="100%" :height="height+15" :x="x" :y="y" ref="svg" v-if="data.cols.length>0">
      <!-- Baseline -->
      <g transform="translate(0 -15)">
      <rect v-if="baseline"
        x="0" :y="getY(0)"
        height="1"
        :width="computedWidth"
        fill="#ddd"
        class="energy-baseline"
        >
      </rect>
      <!-- Bars -->
      <!-- <g v-for="(stack, index) in stacked" :key="'stack'+index">
        <rect v-for="(rect, index2) in stack"  :key="'rect'+index+index2"
          :x="getX(index)"
          :y="getY(rect[0])"
          :height="getY(rect[0])-getY(rect[1])"
          :width="barThickness" 
          stroke="red"/>
      </g> -->
      <g v-for="(catecory, index) in stacked" :key="'catecory'+index">
        <rect v-for="(rect, index2) in catecory"  :key="'rect'+index+index2"
          :x="getX(index2)"
          :y="getY(rect[1])"
          :height="getY(rect[0])-getY(rect[1])"
          :width="barThickness"
          :fill="data.cols[index+1].color"
          />
          <!-- Beschriftung Werte -->
        <text v-for="(rect, index2) in catecory"  :key="'recttext'+index+index2"
         :width="barThickness"
         :x="getX(index2)+barThickness/2"
         :y="getY(rect[0])-3"
         text-anchor="middle"
         fill="#ffffff"
         font-weight="bold"
         font-size="15px">
        {{format(-(rect[0]-rect[1]))}}
      </text>
      </g>

      <!-- Labels unter den Säulen -->
      <text 
      :key="'labelleft'"
        :x="getX(0)+barThickness/2" 
        :y="height-5"
        text-anchor="middle"
        fill="#666666"
        font-size="13px"
        class="grid-label">
        {{dates[0]}}
      </text>
      <text
        :key="'labelright'"
        :x="getX(1)+barThickness/2" 
        :y="height-5"
        text-anchor="middle"
        fill="#666666"
        font-size="13px"
        class="grid-label">
        {{dates[1]}}
      </text>
    </g>
      <!-- Values -->
      <!--<text v-for="(row, index) in data.rows"
        :key="'value'+index"
        :x="getX(1)" 
        :y="getY(1)"
        text-anchor="middle"
        :font-size="fontSize"
        class="grid-label">
        {{format(row)}}
    </text>-->
  </svg>

   <!-- Legende -->
    <div class="energy-legend">
      <div class="energy-legend-box" :style="{'background-color':data.cols[1].color}"></div>
      <div class="energy-legend-text">{{data.cols[1].label}}</div>
      <div class="energy-legend-box" :style="{'background-color':data.cols[2].color}"></div>
      <div class="energy-legend-text">{{data.cols[2].label}}</div>
    </div>
    

  </div> 
</template>

<script>
import {scaleLinear} from 'd3' //scaleTime, , format
import {stack} from 'd3-shape'
import debounce from 'debounce'

export default {
  name: 'StackedColumnChart',
  props: {
    data: Object,
    colors: Array,
    height: { type: Number, default: 200 },
    width: { type: String, default: '100%' },
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    yRange: Array,
    suffix: String,
    fontSize: { type: Number, default: 16 },
    barMargin: { type: Number, default: 10 },
    plusminus: { type: Boolean, default: false },
    baseline: { type: Boolean, default: false },
    elipsis: { type: Boolean, default: true },
  },
  data () {
    return {
      computedWidth: 600,
      // barMargin: 5,
    }
  },
  methods: {
    fitProjection () {
      if (this.width != '100%') {
        this.computedWidth = this.width
      } else {
        this.computedWidth = this.$refs.svg.getBoundingClientRect().width
      }
    },
    format (number) {
      let prefix = ''
      
      if(this.plusminus) {
        if (number==0) {
          prefix = '±'
        } else if (number > 0) {
          prefix = '+'
        } else {
          prefix = ''
        }
      }
      
      return prefix + String(number).replace('.',',') + (this.suffix||'')
    },
    formatDate (str) {
      const date = new Date(str)
      return date.toLocaleDateString()
    },
    capLength (str) {
      let maxLength = parseInt(this.barThickness/10)
      if (str.length>maxLength&&this.elipsis) {
        return str.slice(0,maxLength) + '...'
      } else {
        return str
      }
    },
    getY (val) {
      let x = scaleLinear()
        .domain(this.yRangeComputed)
        .range([this.height-20, 20])
      return x(val)
    },
    getX (index) {
      return index*this.barThickness + index*this.barMargin
    }
  },
  computed: {
    yRangeComputed: function () {
      if (this.yRange) {
        return this.yRange
      } else {
        // let min = Math.min(...this.data.rows[0])
        // if (min > 0) { min = 0 }
        let max = this.stacked.slice(-1)[0].map(el => Math.max(...el))
        max = Math.max(...max)
        // console.log('max: ', max)
        return [0, max]
      }
    },
    barThickness: function () {
      let n = this.data.rows.length //+2
      // return n
     return (this.computedWidth - this.barMargin*(n-1))/n
    },
    stacked: function () {
      let data = []

      this.data.rows.forEach( row => {
        let obj = {}
        
        row.slice(1).forEach( (col, index) => {
          obj[String(index)] = col
        })

        data.push(obj)
      })
      
      //console.log(Object.keys(data[0]))

      const stackk = stack()
        .keys(Object.keys(data[0]))
        // .order(d3.stackOrderNone)
        // .offset(d3.stackOffsetNone);

      
      return stackk(data)
    },
    dates: function () {
      let data = []

        this.data.dates.forEach( row => {
          data.push(row)
        })
       return data
    }
  },
  mounted () {
    this.fitProjection()
    window.addEventListener('resize', debounce(this.fitProjection, 250))
    setTimeout(() => { this.fitProjection() }, 2000)

  },
  updated () {
    this.fitProjection()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>